import React from "react";
import {
  DialogTitle,
  Stack,
  Paper,
  Typography,
  DialogActions,
  Button,
  Dialog,
  Tooltip,
  DialogContent,
  useTheme,
  Box,
  LinearProgress,
} from "@mui/material";

const getUploadPercent = (uploadProgress) => {
  if (Number.isFinite(uploadProgress?.percent)) return Math.min(100, Math.max(0, uploadProgress.percent));
  if (uploadProgress?.total) return Math.min(100, Math.max(0, (uploadProgress.progress / uploadProgress.total) * 100));
  return 0;
};

const UploadProgressModal = ({
  selectedFiles = [],
  showUploadDialog = false,
  uploadProgress = { progress: 0, rate: 0, total: 0, buffer: 10 },
}) => {
  const percent = getUploadPercent(uploadProgress);

  return (
    <div>
      <Dialog
        open={showUploadDialog}
        PaperProps={{
          style: {
            maxWidth: "700px",
            minWidth: "500px",
          },
        }}
      >
        <DialogTitle>
          <Stack>
            <Typography>{`File(s) :  `}</Typography>
            <Typography>{selectedFiles.map((item) => item.name)?.join("\n") || ""}</Typography>
          </Stack>
          <div>
            <Stack direction={"row"} my={2}>
              <Typography mr={3}>{`Progress : ${uploadProgress?.progress || 0}/${uploadProgress?.total || 0} MB`}</Typography>
              <Typography mr={3}>{`Speed : ${uploadProgress?.rate || 0} MB/sec`}</Typography>
            </Stack>
            <LinearProgress
              sx={{ mb: 1 }}
              variant={percent > 0 ? "buffer" : "indeterminate"}
              value={percent}
              valueBuffer={uploadProgress?.buffer || Math.min(100, percent + 10)}
            />
          </div>
        </DialogTitle>
      </Dialog>
    </div>
  );
};

export default UploadProgressModal;
